const BASE_PATH = "/verify";
export const TRUST_PATHS = {
  base: BASE_PATH,
  grid: () => BASE_PATH,
  assessment: (id: string) => `${BASE_PATH}/${id}`,
  standardAnswers: () => `${BASE_PATH}/standard-answers`,
  login: () => `${BASE_PATH}/login`,
};
